<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" :tab="$t('promotion.buyItemFreeItem')">
              <div class="ts-space-y-4">
                <div class="row">
                  <div class="col-md-7">
                    <form class="form-horizontal ts-space-y-3">
                      <div class="row">
                        <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{
                          $t('promotion.eventName') }}</label>
                        <div class="col-md-8">
                          <input v-model="model.promotion_name" type="text" class="form-control" />
                          <div class="validate ts-text-xs" v-if="errors.has('promotion_name')">{{
                            errors.first('promotion_name') }}</div>
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{
                          $t('promotion.startDate') }}</label>
                        <div class="col-md-8">
                          <a-date-picker v-model="model.promo_start_date" class="ts-w-full" format="DD-MM-YYYY"
                            valueFormat="DD-MM-YYYY"></a-date-picker>
                          <div class="validate ts-text-xs" v-if="errors.has('promo_start_date')">{{
                            errors.first('promo_start_date') }}</div>
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-md-3 col-form-label ts-text-xs"></label>
                        <div class="col-md-8">
                          <ts-checkbox v-model="model.is_no_end_date" class="ts-font-light"
                            @change="() => model.promo_end_date = null">{{ $t('promotion.tillFurtherNotice')
                            }}</ts-checkbox>
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-md-3 col-form-label ts-text-xs ts-font-light"
                          :class="!model.is_no_end_date ? 'required' : null">{{ $t('promotion.endDate') }}</label>
                        <div class="col-md-8">
                          <a-date-picker v-model="model.promo_end_date" :disabled="model.is_no_end_date"
                            class="ts-w-full" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"></a-date-picker>
                          <div class="validate ts-text-xs" v-if="errors.has('promo_end_date')">{{
                            errors.first('promo_end_date') }}</div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-3">
                    <div class="ts-w-full ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
                      <BranchList v-model="model" />
                      <div class="validate ts-text-xs" v-if="errors.has('branch_id_list')">{{
                        errors.first('branch_id_list') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="ts-w-full ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
                      <Modules v-model="model" />
                      <div class="validate ts-text-xs" v-if="errors.has('branch_id_list')">{{
                        errors.first('branch_id_list') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ScheduleDay v-model="model" :validate="errors" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <BuyItemFreeItem v-model="model" :validate="errors" />
                    <div class="validate ts-text-xs" v-if="errors.has('condition')">{{ errors.first('condition') }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                    <ts-button @click.prevent="$router.push({ name: 'promotion' })">{{ $t('cancel') }}</ts-button>
                    <ts-button :waiting="waiting" @click.prevent="onUpdate" color="primary">{{ $t('update')
                    }}</ts-button>
                  </div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import BranchList from './components/branch-list'
import Modules from './components/modules'
import BuyItemFreeItem from './components/buy-item-free-item-condition'
import ScheduleDay from './components/schedule_day'

export default {
  name: 'buyItemFreeItemEdit',
  components: {
    BranchList,
    Modules,
    BuyItemFreeItem,
    ScheduleDay
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        promotion_id: null,
        promotion_name: '',
        promo_type_id: 4,
        is_no_end_date: false,
        promo_start_date: '',
        promo_end_date: '',
        branch_id_list: [],
        modules: [],
        condition: [],
        promo_schedule_list: []
      }
    }
  },
  methods: {
    ...mapActions('promotion/buyItemFreeItem', ['update', 'find']),
    ...mapActions('promotion/resource', ['getBranch', 'getSaleCode']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
      await this.getSaleCode()
      await this.setEditData()
      this.loading = false
    },
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.promotion_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async setEditData() {
      await this.find(this.$route.params.id)
        .then(response => {
          let data = response.data
          this.setState(data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    setState(data) {
      this.model.promotion_id = data.promotion_id
      this.model.promotion_name = data.promotion_name
      this.model.prom_type_id = 4
      this.model.is_no_end_date = data.is_no_end_date
      this.model.promo_start_date = data.promo_start_date
      this.model.promo_end_date = data.promo_end_date
      this.model.branch_id_list = data.branches.map(el => el.branch_id)
      this.model.modules = data.modules
      this.model.condition = data.condition.map(el => (
        {

          pro_sale_code_id_buy: el.pro_sale_code_id_buy,
          buy_quantity: el.buy_quantity,
          condition_type: el.condition_type,
          is_allow_adjust_free_quantity: el.is_allow_adjust_free_quantity,
          freeItem: el.free_item_list.map(el => ({
            pro_sale_code_id_free: parseInt(el.pro_sale_code_id_free),
            free_quantity: parseInt(el.free_quantity),
            price: parseFloat(el.price)
          }))
        }
      ))

      this.model.promo_schedule_list = []

      for (var i = 1; i <= 7; i++) {
        this.model.promo_schedule_list.push({
          day_id: data.schedules
            .filter(d => d.day_id == i)
            .reduce((i, v) => (i = v.day_id), null),
          time_from: data.schedules
            .filter(d => d.day_id == i)
            .reduce((i, v) => (i = v.time_from), null),
          time_to: data.schedules
            .filter(d => d.day_id == i)
            .reduce((i, v) => (i = v.time_to), null),
          order: i
        })
      }

      this.model.promo_schedule_list = _.orderBy(
        this.model.promo_schedule_list,
        ['order'],
        ['asc']
      )
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/resource/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>